import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoGooglePlay = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fillRule: "evenodd",
	clipRule: "evenodd",
	imageRendering: "optimizeQuality",
	shapeRendering: "geometricPrecision",
	textRendering: "geometricPrecision",
	viewBox: "0 0 466 511.98",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "nonzero",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#ea4335",
				d: "M199.9 237.8 1.4 470.17c7.22 24.57 30.16 41.81 55.8 41.81 11.16 0 20.93-2.79 29.3-8.37l244.16-139.46z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fbbc04",
				d: "m433.91 205.1-104.65-60-111.61 110.22 113.01 108.83 104.64-58.6c18.14-9.77 30.7-29.3 30.7-50.23-1.4-20.93-13.95-40.46-32.09-50.22"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#34a853",
				d: "M199.42 273.45 329.27 145.1 87.9 8.37C79.53 2.79 68.36 0 57.2 0 30.7 0 6.98 18.14 1.4 41.86z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4285f4",
				d: "M1.39 41.86C0 46.04 0 51.63 0 57.2v397.64c0 5.57 0 9.76 1.4 15.34l216.27-214.86z"
			})
		]
	})
});
export default SvgLogoGooglePlay;
